import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Edit, X, Save, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import MaraSportsLogo from '../MaraSportsLogo';

const ProfileHeader = ({ 
    title, 
    backLink = '/dashboard', 
    isMyProfile = false,
    editing = false,
    saving = false,
    onEdit,
    onCancel,
    onSave
}) => {
    return (
        <header className="sticky top-0 z-30 bg-[#0a1628]/80 backdrop-blur-lg border-b border-white/5">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="flex items-center justify-between h-16">
                    <div className="flex items-center gap-4">
                        <Link to={backLink} className="flex items-center gap-2 text-muted-foreground hover:text-white">
                            <ArrowLeft className="w-4 h-4" />
                        </Link>
                        <span className="font-heading font-bold text-lg uppercase">{title}</span>
                    </div>

                    <div className="flex items-center gap-4">
                        {isMyProfile && !editing && onEdit && (
                            <Button
                                onClick={onEdit}
                                variant="outline"
                                className="border-primary text-primary hover:bg-primary/10"
                                data-testid="edit-profile-btn"
                            >
                                <Edit className="w-4 h-4 mr-2" />
                                Edit Profile
                            </Button>
                        )}
                        {editing && (
                            <>
                                <Button
                                    onClick={onCancel}
                                    variant="outline"
                                    className="border-white/20"
                                    data-testid="cancel-edit-btn"
                                >
                                    <X className="w-4 h-4 mr-2" />
                                    Cancel
                                </Button>
                                <Button
                                    onClick={onSave}
                                    disabled={saving}
                                    className="bg-primary hover:bg-cyan-400 text-[#0a1628]"
                                    data-testid="save-profile-btn"
                                >
                                    {saving ? (
                                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                    ) : (
                                        <Save className="w-4 h-4 mr-2" />
                                    )}
                                    Save
                                </Button>
                            </>
                        )}
                        <MaraSportsLogo className="h-10" />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default ProfileHeader;
